import React from 'react';
import maggie from '../assets/magggie.png';
import { Link } from 'react-router-dom';
import { IoMdArrowRoundBack } from 'react-icons/io'; // Import the back icon

const Option = () => {
  return (
    <div className="relative ">
      {/* Back Icon outside the main content */}
      <Link
        to="/"
        className="absolute top-4 left-4  text-black  hover:text-gray-300  transition ont-semibold text-2xl "
      >
        <IoMdArrowRoundBack />
      </Link>

      <div className="h-[600px] flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto p-6 bg-white rounded-lg">
        {/* Left Section */}
        <div className="w-full md:w-1/2 text-center md:text-center mb-6 md:mb-0">
          <h2 className="text-2xl font-bold text-gray-800 text-center">
            Start your stay with ease.
          </h2>
          <p className="text-base text-gray-600 mb-14 text-center">
            Choose to check in now or plan your departure.
          </p>
          <p className="text-lg text-black mb-6 text-center font-bold">
            What would you like to do ?
          </p>

          <div className="flex gap-4">
            <Link
              to="/check-in/options"
              className="bg-cyan-500 text-white px-6 py-3 w-1/2 text-center rounded-md hover:text-black transition"
            >
              Check In
            </Link>

            <Link
              to="/check-out-field"
              className="bg-cyan-500 text-white px-6 py-3 w-1/2 text-center rounded-md hover:text-black transition"
            >
              Check Out
            </Link>
          </div>
        </div>

        {/* Right Section */}
        <div className="relative w-full md:w-1/2 flex justify-center items-center">
          {/* Floating Comment */}
          <div className="absolute top-10 bg-gray-200 text-gray-800 text-xs rounded-tl-lg rounded-br-md p-3 max-w-48 text-center">
            Hi, I’m Maggie! I’m here to guide you through check-in, reservations, and any assistance
            you may need. <br />
            <span className="font-semibold text-xs">
              If you are new here, then go with the Check-In option.
            </span>
          </div>

          <img
            src={maggie}
            alt="Maggie"
            className="w-64 h-64 md:w-80 md:h-80 object-contain mt-32 ml-56"
          />
        </div>
      </div>
    </div>
  );
};

export default Option;

// import React from "react";
// import maggie from "../assets/magggie.png";
// import { Link } from "react-router-dom";

// const Option = () => {
//   return (
//     <div className=" h-[600px] flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto p-6 bg-white rounded-lg relative">
//       {/* Left Section */}
//       <div className="w-full md:w-1/2 text-center  md:text-center mb-6 md:mb-0">
//         <h2 className="text-2xl font-bold text-gray-800  text-center">
//           Start your stay with ease.
//         </h2>
//         <p className="text-base text-gray-600 mb-14 text-center">
//           Choose to check in now or plan your departure.
//         </p>
//         <p className="text-lg text-black mb-6 text-center font-bold">
//           What would you like to do ?
//         </p>

//         <div className="flex gap-4">
//   <Link
//     to="/check-in/options"
//     className="bg-cyan-500 text-white px-6 py-3 w-1/2 text-center rounded-md hover:text-black transition"
//   >
//     Check In
//   </Link>

//   <Link
//     to="/check-out-field"
//     className="bg-cyan-500 text-white px-6 py-3 w-1/2 text-center rounded-md hover:text-black transition"
//   >
//     Check Out
//   </Link>
// </div>
//       </div>

//       {/* Right Section */}
//       <div className="relative w-full md:w-1/2 flex justify-center items-center">
//         {/* Floating Comment */}
//         <div className="absolute top-10 bg-gray-200 text-gray-800 text-xs rounded-tl-lg rounded-br-md p-3 max-w-48 text-center">
//           Hi, I’m Maggie! I’m here to guide you through check-in, reservations,
//           and any assistance you may need. <br />
//           <span className="font-semibold text-xs">
//             If you are new here, then go with the Check-In option.
//           </span>
//         </div>

//         <img
//           src={maggie}
//           alt="Maggie"
//           className="w-64 h-64 md:w-80 md:h-80 object-contain mt-32 ml-56"
//         />
//       </div>
//     </div>
//   );
// };

// export default Option;
